import moment from 'moment';

const DEFAULT_DATE_FORMAT = "DD/MM/YYYY";
const DEFAULT_TIME_FORMAT = "HH:mm";
const DEFAULT_DATE_TIME_FORMAT = "DD/MM/YYYY HH:mm"

const DEFAULT_QUERY_DATE_FORMAT = "MM-DD-YYYY";

const ToDateTimeFormat = (date, format) => {
    return moment(date).format( format ? format : DEFAULT_DATE_TIME_FORMAT );
}

const ToDate = (date, format) => {
    return moment(date).format( format ? format : DEFAULT_DATE_FORMAT );
}

const ToTime = (date, format) => {
    return moment(date).format( format ? format : DEFAULT_TIME_FORMAT );
}

export {
    DEFAULT_DATE_FORMAT,
    DEFAULT_TIME_FORMAT,
    DEFAULT_DATE_TIME_FORMAT,
    DEFAULT_QUERY_DATE_FORMAT,
    ToDateTimeFormat,
    ToDate,
    ToTime
}